import axios from "axios";
import * as ActionType from "./verifiedUserPlan.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";

export const getVerifiedUserPlan = () => (dispatch) => {
  apiInstanceFetch
    .get(`admin/verifiedUserPlan`)
    .then((res) => {
      dispatch({ type: ActionType.GET_VERIFIED_USER_PLAN, payload: res.verifiedUserPlan });
    })
    .catch((error) => console.error(error));
};

export const addVerifiedUserPlan = (formData) => (dispatch) => {
  axios
    .post("admin/verifiedUserPlan/create", formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.ADD_VERIFIED_USER_PLAN, payload: res.data.verifiedUserPlan });
        setToast("success", "Verified User Plan Added Successfully !");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.error(error));
};

export const updateVerifiedUserPlan = (formData, id) => (dispatch) => {
  axios
    .patch(`admin/verifiedUserPlan/update?verifiedUserPlanId=${id}`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_VERIFIED_USER_PLAN,
          payload: { editPlan: res.data.verifiedUserPlan, id: id },
        });
        setToast("success", "Verified User Plan Updated Successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

export const isActiveVerifiedUserPlan = (id, data) => (dispatch) => {
  axios
    .patch(`admin/verifiedUserPlan/handleisActive?verifiedUserPlanId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.ACTIVE_VERIFIED_USER_PLAN,
          payload: { planActiveData: res.data.verifiedUserPlan, planId: id },
        });
        setToast(
          "success",
          data === true ? "Verified User Plan Active Successfully" : "Verified User Plan Disabled Successfully"
        );
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const deleteVerifiedUserPlan = (id) => (dispatch) => {
  axios
    .delete(`admin/verifiedUserPlan/delete?verifiedUserPlanId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_VERIFIED_USER_PLAN, payload: id });
        setToast("success", "Verified User Plan Deleted Successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};
